// Ce fichier contient les références vers les images du site
// Toutes les images HEIC ont été converties en WebP pour de meilleures performances

export const heroImages = {
  home: '/images/webp/paysageGénéral.webp',
  restaurant: '/images/webp/paysageInterieurRestaurant.webp',
  etangs: '/images/webp/paysageEtangGauche2.webp',
  tarifs: '/images/webp/paysageGénéral2.webp',
  galerie: '/images/webp/paysagePisciculture.webp',
  contact: '/images/webp/paysageCarpo.webp',
};

export const restaurantImages = {
  exterior: '/images/webp/paysageInterieurRestaurant.webp',
  interior: '/images/webp/portraitTerrasse.webp',
  terrace: '/images/webp/portraitTerrasse2.webp',
  terrace2: '/images/webp/portraitTerrasse3.webp',
  terrace3: '/images/webp/portraitTerrasse4.webp',
  terrace4: '/images/webp/portraitTerrasse5.webp',
  service: '/images/webp/portraitGénéral.webp',
};

export const etangsImages = {
  // Grand étang (Carpo)
  grandEtang1: '/images/webp/paysageCarpo.webp',
  grandEtang2: '/images/webp/paysageCarpo2.webp',
  grandEtangPortrait1: '/images/webp/portraitCarpo.webp',
  grandEtangPortrait2: '/images/webp/portraitCarpo2.webp',
  grandEtangPortrait3: '/images/webp/portraitCarpo3.webp',
  grandEtangPortrait4: '/images/webp/portraitCarpo4.webp',
  grandEtangRiviere1: '/images/webp/portraitCarpoRiviere.webp',
  grandEtangRiviere2: '/images/webp/portraitCarpoRiviere2.webp',
  
  // Étang des truites (Étang gauche)
  etangTruites1: '/images/webp/paysageEtangGauche.webp',
  etangTruites2: '/images/webp/paysageEtangGauche2.webp',
  etangTruites3: '/images/webp/paysageEtangGauche3.webp',
  etangTruites4: '/images/webp/paysageEtangGauche4.webp',
  etangTruites5: '/images/webp/paysageEtangGauche5.webp',
  etangTruitesPortrait1: '/images/webp/portraitEtangGauche.webp',
  etangTruitesPortrait2: '/images/webp/portraitEtangGauche2.webp',
  etangTruitesPortrait3: '/images/webp/portraitEtangGauche3.webp',
  
  // Petit étang (Étang droit)
  petitEtang1: '/images/webp/paysageEtangDroit.webp',
  petitEtangPortrait1: '/images/webp/portraitEtangDroit.webp',
  
  // Autres vues
  riviere1: '/images/webp/portraitRiviere.webp',
  riviere2: '/images/webp/portraitRiviere2.webp',
  ponton: '/images/webp/portraitPonton.webp',
  pisciculture1: '/images/webp/paysagePisciculture.webp',
  pisciculture2: '/images/webp/paysagePisciculture2.webp',
  pisciculturePortrait: '/images/webp/portraitPisciculture.webp',
  pisciculturePortrait2: '/images/webp/portraitPisciculture2.webp',
  pisciculturePortrait3: '/images/webp/portraitPisciculture3.webp',
};

export const generalImages = {
  vue1: '/images/webp/paysageGénéral.webp',
  vue2: '/images/webp/paysageGénéral2.webp',
  vuePortrait1: '/images/webp/portraitGénéral.webp',
  vuePortrait2: '/images/webp/portraitGénéral2.webp',
  vuePortrait3: '/images/webp/portraitGénéral3.webp',
};

// Photos pour la galerie
export const galerieImages = [
  {
    id: 1,
    src: '/images/webp/paysageGénéral.webp',
    alt: 'Vue panoramique sur le domaine',
    category: 'exterieur'
  },
  {
    id: 2,
    src: '/images/webp/paysageInterieurRestaurant.webp',
    alt: 'Restaurant extérieur',
    category: 'restaurant'
  },
  {
    id: 3,
    src: '/images/webp/paysageEtangGauche2.webp',
    alt: 'Étang des truites',
    category: 'peche'
  },
  {
    id: 4,
    src: '/images/webp/portraitTerrasse.webp',
    alt: 'Terrasse du restaurant',
    category: 'restaurant'
  },
  {
    id: 5,
    src: '/images/webp/portraitGénéral.webp',
    alt: 'Vue du domaine',
    category: 'exterieur'
  },
  {
    id: 6,
    src: '/images/webp/paysageCarpo.webp',
    alt: 'Grand étang - Carpo',
    category: 'peche'
  },
  {
    id: 7,
    src: '/images/webp/portraitRiviere.webp',
    alt: 'Rivière traversant le domaine',
    category: 'exterieur'
  },
  {
    id: 8,
    src: '/images/webp/portraitCarpo.webp',
    alt: 'Pêche à la carpe',
    category: 'peche'
  },
  {
    id: 9,
    src: '/images/webp/paysagePisciculture.webp',
    alt: 'Pisciculture',
    category: 'peche'
  },
  {
    id: 10,
    src: '/images/webp/portraitPonton.webp',
    alt: 'Ponton de pêche',
    category: 'peche'
  },
  {
    id: 11,
    src: '/images/webp/paysageEtangDroit.webp',
    alt: 'Petit étang',
    category: 'peche'
  },
  {
    id: 12,
    src: '/images/webp/portraitTerrasse2.webp',
    alt: 'Détails de la terrasse',
    category: 'restaurant'
  },
  {
    id: 13,
    src: '/images/webp/portraitGénéral3.webp',
    alt: 'Vue sur le domaine',
    category: 'exterieur'
  },
  {
    id: 14,
    src: '/images/webp/portraitEtangGauche.webp',
    alt: 'Bord de l\'étang des truites',
    category: 'peche'
  },
  {
    id: 15,
    src: '/images/webp/portraitPisciculture3.webp',
    alt: 'Installation de pisciculture',
    category: 'peche'
  },
];

// Tableau de données pour la création d'un carrousel ou un slider
export const sliderImages = [
  {
    id: 1,
    src: '/images/webp/paysageGénéral.webp',
    alt: 'Vue panoramique',
    title: 'Vue panoramique sur le domaine',
    description: 'Découvrez notre domaine niché au cœur du Morvan'
  },
  {
    id: 2,
    src: '/images/webp/paysageInterieurRestaurant.webp',
    alt: 'Restaurant',
    title: 'Restaurant gastronomique',
    description: 'Une cuisine locale et de saison, préparée avec passion'
  },
  {
    id: 3,
    src: '/images/webp/paysageEtangGauche2.webp',
    alt: 'Pêche',
    title: 'Nos étangs de pêche',
    description: 'Trois étangs pour tous les types de pêcheurs'
  },
  {
    id: 4,
    src: '/images/webp/portraitPisciculture2.webp',
    alt: 'Pisciculture',
    title: 'Notre pisciculture',
    description: 'Des poissons d\'eau douce élevés sur place'
  },
  {
    id: 5,
    src: '/images/webp/paysageCarpo.webp',
    alt: 'Grand étang',
    title: 'Le grand étang',
    description: 'Idéal pour la pêche à la carpe'
  },
];

// Instructions importantes pour les images
export const imageRequirements = {
  formats: ['jpg', 'png', 'webp'],
  heroSize: '1920x1080px minimum, ratio 16:9',
  gallerySize: '800x600px minimum, ratio 4:3',
  productSize: '600x800px minimum, ratio 3:4',
  maxFileSize: '5MB par image',
  optimization: 'Les images ont été converties en WebP pour de meilleures performances'
};

// Remarque: Créer un dossier 'public/images/' et y placer toutes les images
// référencées dans ce fichier avec les noms correspondants 